export default __webpack_public_path__ + "assets/images/1cf34b5fc89fe3177f4bf4f8ec49105b.png";